import AxModal from '@/components/03-components/modal/modal';

import { IAxModalOptions, IFooterButton } from '@/components/03-components/modal/modal';

export interface IAxDialogOptions {
    animationStyle: string;
    bodyContent: string;
    className: string;
    clickOutsideToClose: boolean;
    closeIconButton: boolean;
    footerButtons: IFooterButton[];
    headerBarStyle?: string; // only used for dialogs
    id: string;
    lazyBuild: boolean;
    overlay: boolean;
    position: string;
    title: string;
    titleIcon?: string; // only used for dialogs
    zIndex: number;
}

export default class AxDialog extends AxModal {
    public constructor(optionsParam: IAxDialogOptions) {
        const componentType = 'dialog';
        const dialogOptions: IAxDialogOptions | IAxModalOptions = {
            animationStyle: '',
            bodyContent: '', // String or HTML
            className: '',
            clickOutsideToClose: false,
            closeIconButton: true, // On by default
            headerBarStyle: 'default', // Default, inverted, or alert
            footerButtons: [
                // Array of objects
                {
                    text: 'Button',
                    type: 'primary', // Primary, secondary, tertiary, link, cautionary
                    position: 'right', // Right or left
                    onClick: null // pass in a function
                }
            ],
            id: '',
            lazyBuild: false, // Build the modal either at instantiation or on show()
            overlay: true, // The modal backdrop
            title: '', // String
            titleIcon: '', // String - success, info, warn, error, system // TODO rename this
            zIndex: 9999, //
            position: 'center'
        };

        if (optionsParam && typeof optionsParam === 'object') {
            Object.assign(dialogOptions, optionsParam, {
                helpIconButton: false,
                popoutIconButton: false
            });
        }

        super(dialogOptions, componentType);
    }
}
